import React, { Component } from "react";

export default class ExperienceImg extends Component {
  render() {
    const { theme } = this.props;

    return (
      <svg
        className="experience-illustration"
        xmlns="http://www.w3.org/2000/svg"
        width="400"
        height="260"
        viewBox="0 0 400 260"
      >
        {/* background card */}
        <defs>
          <linearGradient id="exp-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={theme.imageHighlight} stopOpacity="0.15" />
            <stop offset="1" stopColor={theme.imageHighlight} stopOpacity="0.35" />
          </linearGradient>
        </defs>

        <rect
          x="15"
          y="20"
          width="370"
          height="220"
          rx="24"
          fill="url(#exp-bg)"
        />

        {/* heading pill */}
        <rect
          x="120"
          y="30"
          width="160"
          height="26"
          rx="13"
          fill={theme.text}
          opacity="0.08"
        />
        <circle cx="135" cy="43" r="4" fill={theme.imageHighlight} />
        <circle cx="150" cy="43" r="4" fill={theme.text} opacity="0.6" />
        <circle cx="165" cy="43" r="4" fill={theme.text} opacity="0.3" />

        {/* center timeline line */}
        <line
          x1="200"
          y1="70"
          x2="200"
          y2="220"
          stroke={theme.text}
          strokeWidth="2"
          strokeLinecap="round"
          className="exp-timeline-line"
        />

        {/* three experience nodes */}
        {[
          { cy: 90, label: "Internship" },
          { cy: 145, label: "Junior Dev" },
          { cy: 200, label: "Engineer" },
        ].map((step, index) => (
          <g key={step.label}>
            {/* node circle */}
            <circle
              cx="200"
              cy={step.cy}
              r="10"
              fill="#fff"
              stroke={theme.imageHighlight}
              strokeWidth="2"
              className={`exp-node exp-node-${index}`}
            />
            {/* left label card */}
            <rect
              x="50"
              y={step.cy - 16}
              width="120"
              height="32"
              rx="10"
              fill="#ffffff"
              opacity="0.95"
              className="exp-card"
            />
            <rect
              x="58"
              y={step.cy - 10}
              width="70"
              height="6"
              rx="3"
              fill={theme.text}
              opacity="0.6"
            />
            <rect
              x="58"
              y={step.cy + 2}
              width="90"
              height="4"
              rx="2"
              fill={theme.text}
              opacity="0.25"
            />

            {/* right tag pill */}
            <rect
              x="230"
              y={step.cy - 12}
              width="110"
              height="24"
              rx="12"
              fill={theme.imageHighlight}
              opacity="0.85"
              className="exp-pill"
            />
            <text
              x="285"
              y={step.cy + 4}
              textAnchor="middle"
              fontSize="11"
              fill={theme.dark || theme.text}
              style={{ fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, sans-serif" }}
            >
              {step.label}
            </text>
          </g>
        ))}
      </svg>
    );
  }
}
